import TPL = require("templates");
import {Config} from "../config";

export class ManageGuestsController {

  static eventId;

  ngTagsInput;
  tags;
  reservationMessage;
  maxguestsError;
  numberGuestsMax;


  private eventId;

  scope = {
    params: "=params"
  };
  link;

  static $inject = ["session", "$uibModalInstance", "$log", "$route"];

  constructor(
    public session,
    private modalInstance,
    private log,
    private route
  ) {

    this.eventId = ManageGuestsController.eventId;

    this.session.loadEvent(this.eventId);
    this.session.loadReservations(this.eventId);
  }

  approveReservation(reservationId) {
    this.log.debug("TODO APPROVE: " + reservationId);

    this.session.loadReservations(this.eventId);
    this.session.acceptReservation(reservationId).then((response) => {
      this.log.debug("acceptReservation");
      this.log.debug(response);
    }).then(() => {
      this.session.loadReservations(this.eventId);
      this.session.loadEvent(this.eventId);
      this.route.reload();
    }).catch((error) => {
      this.maxguestsError = this.session.getData().reservationListStatus;
      this.numberGuestsMax = this.session.getData().event.number_of_guests_max;
    });;
  }

  denyReservation(reservationId) {
    this.log.debug("TODO DENY: " + reservationId);

    this.session.rejectReservation(reservationId).then((response) => {
      this.log.debug("denyReservation");
      this.log.debug(response);
    }).then(() => {
      this.session.loadReservations(this.eventId);
    });
  }

  getReservationList() {
    var list = this.session.getData().reservationList;
    if(list != null) {
      var returnList = [];
      angular.forEach(list, (reservation) => {
        if(reservation.state != 'rejected') {
          returnList.push(reservation);
        }
      });
      return returnList;
    } else {
      return [];
    }
  }

  getReservationListPending() : number {
    var list = this.session.getData().reservationList;
    if(list != null) {
      var returnListCount = 0;
      angular.forEach(list, (reservation) => {
        if(reservation.state == 'pending') {
          returnListCount++;
        }
      });
      return returnListCount;
    } else {
      return 0;
    }
  }

  getGuestsPending() : number {
    if (this.session.getData().event && typeof this.session.getData().event != "undefined"){
      var pending_guests = this.session.getData().event.reservations_stats.guests_pending;
      return pending_guests;
    }

  }

  getReservationListAccepted() : number {
    var list = this.session.getData().reservationList;
    if(list != null) {
      var returnListCount = 0;
      angular.forEach(list, (reservation) => {
        if(reservation.state == 'accepted') {
          returnListCount++;
        }
      });
      return returnListCount;
    } else {
      return 0;
    }
  }

  getGuestsAccepted() : number {
    if (this.session.getData().event && typeof this.session.getData().event != "undefined"){
        var accepted_guests = this.session.getData().event.reservations_stats.guests_accepted;
        return accepted_guests;
    }
  }

  isEventHosted() {
    if(this.session.getData().event !== undefined && this.session.getData().event.created_by_profile.id === this.session.user.user_id ) {
      return true;
    }
  }

  static open(modal, eventId) {

    ManageGuestsController.eventId = eventId;

    return modal.open({
      controller: ManageGuestsController,
      controllerAs: "vm",
      replace: true,
      size: "md",
      template: TPL.modals.manageGuests
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/manageGuests.ts
 **/